import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter)
// 解决路由重复报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [

  {
    path: '/',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/navbar',
    name: 'navbar',
    redirect: '/company',
    component: () => import('../components/navbar/navbar.vue'),
    children: [
      {
        path: '/company',
        name: 'company',
        component: () => import('../views/company.vue')
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('../views/product.vue')
      },
      {
        path: '/news',
        name: 'news',
        component: () => import('../views/news.vue')
      },
      {
        path: '/staff',
        name: 'staff',
        component: () => import('../views/staff.vue')
      }
    ]
  },
  {
    path: '/seriesEditing/:item',
    name: 'product_seriesEditing',
    component: () => import('../views/product_seriesEditing.vue')
  }, 
  {
    path: '/seriesCheck/:item',
    name: 'product_seriesCheck',
    component: () => import('../views/product_seriesCheck.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
function checkIfUserIsLoggedIn() {
  const token = localStorage.getItem('token');
  return !!token;
}

router.beforeEach((to, from, next) => {
  const loggedIn = checkIfUserIsLoggedIn(); // 自定义函数，用于检查用户是否已登录

  if (!loggedIn && to.path !== '/') {
    next('/'); // 如果未登录且访问的不是登录页，则跳转到登录页
  } else {
    next(); // 已登录或访问登录页，继续正常访问
  }

  // next(); // 已登录或访问登录页，继续正常访问
})

export default router
